import { MultiLangString } from '../MultiLangString';
import { CwlTierReportNarrative } from '../omi-surveys/narrative-report.model';

export interface OmiCaregiverWorkloadOption {
  tag: string;
  label: MultiLangString;
}

export interface OmiCaregiverWorkloadStep {
  stepNo: number;
  title: MultiLangString;
  description: MultiLangString;
  multiSelect: boolean;
  options: OmiCaregiverWorkloadOption[];
}

export interface OmiCaregiverWorkloadSurvey {
  _id: string;
  title: MultiLangString;
  introduction: MultiLangString;
  steps: OmiCaregiverWorkloadStep[];
  /** Plain-text narrative per tier key; layout is in the caregiver-workload-report component. */
  reportSections?: Partial<Record<string, CwlTierReportNarrative>>;
}

export interface OmiCaregiverWorkloadUserAnswer {
  stepNo: number;
  selectedTags: string[];
}

export interface OmiCaregiverWorkloadResponse {
  _id: string;
  surveyId: string;
  userName: string;
  userEmail: string;
  userSex: string;
  /** ISO date string (YYYY-MM-DD) when user was born. Optional. */
  userDob?: string;
  /** ISO date string when report was created. */
  dateTime?: string;
  answers: OmiCaregiverWorkloadUserAnswer[];
  tier: 1 | 2 | 3 | 4;
}

export interface CreateOmiCaregiverWorkloadResponseDto {
  surveyId: string;
  userName: string;
  userEmail: string;
  userSex: string;
  /** ISO date string (YYYY-MM-DD). Optional. */
  userDob?: string;
}

export interface SubmitOmiCaregiverWorkloadResponseDto {
  answers: OmiCaregiverWorkloadUserAnswer[];
}
